import type { AgGridSecurityDecorationParams, AgGridSecurityProps } from '../../AgGrid/types';

function defaultShowDescription({ security }: AgGridSecurityDecorationParams): boolean {
  return security?.showBlotterDescription === true;
}

export function resolveSecurityColumnShowDescription(
  params: Pick<AgGridSecurityProps, 'showDescription'> | undefined
): NonNullable<AgGridSecurityProps['showDescription']> {
  return params?.showDescription ?? defaultShowDescription;
}
